import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SearchFormComponent } from '@big-direkt/search';
import { UiButtonComponent } from '@big-direkt/ui/button';
import { UiLinkComponent } from '@big-direkt/ui/link';
import { IconBigBoldWinkelLinks, IconComponent } from '@big-direkt/utils/icons';
import { BreakpointService } from '@big-direkt/utils/shared';
import { translateSignal } from '@jsverse/transloco';
import { SidenavService } from '../../services/sidenav.service';
import { NavMainMobileComponent } from '../nav-main-mobile/nav-main-mobile.component';
import { NavUserComponent } from '../nav-user/nav-user.component';

@Component({
    selector: 'big-nav-sidenav',
    templateUrl: './nav-sidenav.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatSidenavModule,
        IconComponent,
        NavMainMobileComponent,
        NavUserComponent,
        UiButtonComponent,
        UiLinkComponent,
        NgTemplateOutlet,
        SearchFormComponent,
    ],
})
export class NavSidenavComponent {
    public readonly sidenavService = inject(SidenavService);
    public readonly viewport = inject(BreakpointService);
    public readonly iconAngleLeft = IconBigBoldWinkelLinks;

    public readonly backTranslation = translateSignal('nav.back');
    public readonly topGap = computed(() => this.viewport.headerSize().height + this.viewport.topBarSize().height);
    public readonly isOpened = computed(() => {
        switch (this.sidenavService.currentSidenav()) {
            case 'user':
                return !this.viewport.isDesktop();
            case 'nav':
            case 'search':
                return this.viewport.isMobile();
            default:
                return false;
        }
    });
    public readonly subnavOpened = computed(() => this.sidenavService.subnavOpened() && this.isOpened());
}
